import React, { useEffect, useState, useContext } from 'react'
import { useParams, Link } from 'react-router-dom'
import IPPSservice from 'services/IPPSservice'
import { upload } from '../../services/mcp.service'
import ReactForm from 'ua-react-form'
import AppContext from '../../store/AppContext'
const { Update } = ReactForm
import _ from 'lodash'

const BadgeDetail = () => {
    const { id } = useParams()
    const [context, setContext] = useState({ body: {} })
    const { merchants } = useContext(AppContext)
    const onChange = ({ target }) => {
        let con = context
        _.set(con, target.name, target.value)
        setContext(con)
        console.log(con)
    }

    const onChangeImage = async ({ target }) => {
        try {
            if (target.files && target.files[0]) {
                let img = target.files[0]
                const data = new FormData()
                data.append('image', img)
                let result = await upload(data)

                if (result.status_code !== 0) {
                    throw new Error(result.status)
                }

                let con = context
                _.set(con, target.name, result.data.path)
                setContext(con)
            }
        } catch (err) {
            console.log(err)
        }
    }

    const onSubmit = async event => {
        try {
            event.preventDefault()
            const result = await IPPSservice.updateIPPS('badge', id, context)
            console.log(result)
        } catch (err) {
            console.log(err)
        }
    }

    const getData = async () => {
        try {
            let data = await IPPSservice.getOneIPPS('badge', id)
            console.log('Badge', data)
            setContext(data)
        } catch (err) {
            console.log(err)
            setContext({})
        }
    }

    useEffect(async () => {
        await getData()
    }, [])

    const title = 'Update Badge'

    const fields = [
        {
            type: 'text',
            isRequired: true,
            name: 'Нэр',
            fieldName: 'name',
            onChange: onChange
        },
        {
            type: 'select',
            isRequired: true,
            name: 'Merchant',
            fieldName: 'merchant',
            onChange: onChange,
            options: merchants
        },
        {
            type: 'file',
            isRequired: true,
            name: 'Лого',
            fieldName: 'logo',
            onChange: onChangeImage
        },
        {
            type: 'file',
            isRequired: true,
            name: 'Идэвхигүй лого',
            fieldName: 'inactive_logo',
            onChange: onChangeImage
        },
        {
            type: 'text',
            isRequired: true,
            name: 'Тайлбар',
            fieldName: 'description',
            onChange: onChange
        },
        {
            type: 'text',
            isRequired: true,
            name: 'Идэвхигүй тайлбар',
            fieldName: 'inactive_description',
            onChange: onChange
        },
        {
            type: 'text',
            isRequired: true,
            name: 'Shortcode',
            fieldName: 'shortcode',
            onChange: onChange
        },
        {
            type: 'color',
            isRequired: true,
            name: 'Background Color',
            fieldName: 'background',
            onChange: onChange
        },
        {
            type: 'number',
            isRequired: true,
            name: 'Index',
            fieldName: 'index',
            onChange: onChange
        },
        {
            type: 'checkbox',
            isRequired: true,
            name: 'Collective эсэх',
            fieldName: 'is_collective',
            onChange: onChange
        },
        {
            type: 'checkbox',
            name: 'Харагдах эсэх',
            fieldName: 'is_show',
            onChange: onChange
        },
        {
            type: 'checkbox',
            name: 'Груп эсэх',
            fieldName: 'is_group',
            onChange: onChange
        }
    ]

    return (
        <div className="page-content">
            <Update
                fields={fields}
                title={title}
                context={context}
                onSubmit={onSubmit}
            ></Update>
        </div>
    )
}

export default BadgeDetail
